import templateTicketViewContactAdd from './ticketViewContactAdd.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, jsonFactory, eventService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;
      ctrl.countries = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        jsonFactory.getCountries().then((data) => {
          ctrl.countries = data;
          ctrl.destroyWatch = eventService.onTicketViewContactAdd((params) => {
            $mdDialog
              .show({
                targetEvent: params.event,
                locals: {
                  contact: params.contact,
                  contacts: params.contacts,
                  contactLabels: params.contactLabels,
                  workflow: params.workflow
                },
                template: templateTicketViewContactAdd,
                controllerAs: '$ctrl',
                controller(contact, contacts, contactLabels, workflow) {
                  const ctr = this;
                  ctr.contact = contact;
                  ctr.contacts = contacts;
                  ctr.contactLabels = contactLabels;
                  ctr.workflow = workflow;
                  ctr.options = {
                    show: {
                      subTitle: false,
                      delete: false
                    }
                  };
                  ctr.countries = ctrl.countries;

                  ctr.contactAdded = (c) => {
                    ctr.contact = c;
                  };
                  ctr.confirm = () => {
                    if (ctr.contact.isCompany && ctr.contact.name !== '') {
                      $mdDialog.hide(ctr.contact);
                    } else if (
                      !ctr.contact.isCompany &&
                      ctr.contact.name !== '' &&
                      ctr.contact.familyName !== ''
                    ) {
                      $mdDialog.hide(ctr.contact);
                    } else {
                      uiService.toast({
                        text: {
                          p1: 'Contact',
                          p2: ctr.contact.isCompany ? 'Name' : 'First name and family name',
                          p3: ctr.contact.isCompany ? 'is required' : 'are required'
                        },
                        warn: true
                      });
                    }
                  };
                  ctr.cancel = () => {
                    $mdDialog.cancel();
                  };
                }
              })
              .then((result) => {
                ctrl.onFinished({ contact: result });
              });
          });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.items && changes.items.currentValue) {
          ctrl.initialize();
        }
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
